import api from './api';

class FitCloudService {
  async getAccounts() {
    const response = await api.get('/fitcloud/accounts');
    return response.data;
  }
}

export const fitcloudService = new FitCloudService();